export const SHEET_BEER_COLUMNS = [
  'breweryName',
  'state',
  'beerName',
  'styleLabel',
  'abv',
  'styleType',
];

export const SHEET_BEER_COLUMN_SET = new Set(SHEET_BEER_COLUMNS);
